import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";

// Find the user who referred me using referralId
export const findUserWhoReferedMe = async (referralId) => {
  console.log("Finding user with referral ID:", referralId);

  if (!referralId) {
    return null;
  }

  try {
    const usersRef = collection(db, "users");
    const q = query(usersRef, where("myARID", "==", referralId));
    const querySnapshot = await getDocs(q);

    // ❌ If multiple or no users found, it's invalid (myARID should be unique)
    if (querySnapshot.empty || querySnapshot.size > 1) {
      console.warn("Invalid referral ID: either not found or not unique.");
      return null;
    }

    const userDoc = querySnapshot.docs[0];
    const userData = userDoc.data();

    // ✅ If user is a team_member, we must check for a valid team_leader
    if (userData.userType === "team_member") {
      const leaderQuery = query(
        usersRef,
        where("userType", "==", "team_leader"),
        where("myARID", "==", userData?.referralId)
      );
      const leaderSnapshot = await getDocs(leaderQuery);

      if (!leaderSnapshot.empty) {
        // Valid team_member under a team_leader
        return querySnapshot.docs[0].id;
      } else {
        // team_member without a valid leader
        return null;
      }
    }

    // ✅ Valid non-team_member (like a team_leader or regular user)
    return querySnapshot.docs[0].id;
  } catch (error) {
    console.error("Error finding user by referral ID:", error);
    return null;
  }
};
